import DOMPurify from "dompurify";
import { useMemo } from "react";

interface SafeHtmlProps {
  html: string;
  className?: string;
  style?: React.CSSProperties;
  allowScripts?: boolean; // Por defecto false
  allowedTags?: string[]; // Tags permitidos personalizados
  allowedAttributes?: string[]; // Atributos permitidos personalizados
}

export const SafeHtml = ({
  html,
  className,
  style,
  allowScripts = false,
  allowedTags,
  allowedAttributes
}: SafeHtmlProps) => {
  const sanitizedHtml = useMemo(() => {
    if (!html) return "";

    const config: DOMPurify.Config = {
      ALLOWED_TAGS: allowedTags || [
        "p",
        "br",
        "strong",
        "em",
        "u",
        "b",
        "i",
        "span",
        "div",
        "a",
        "ul",
        "ol",
        "li",
        "table",
        "thead",
        "tbody",
        "tr",
        "td",
        "th",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "blockquote",
        "code",
        "pre",
        "img"
      ],
      ALLOWED_ATTR: allowedAttributes || [
        "href",
        "title",
        "class",
        "style",
        "target",
        "colspan",
        "rowspan",
        "align",
        "src",
        "alt"
      ],
      ALLOW_DATA_ATTR: false,
      KEEP_CONTENT: true,
      RETURN_DOM: false,
      RETURN_DOM_FRAGMENT: false,
      RETURN_TRUSTED_TYPE: false,
      FORBID_TAGS: ["script", "iframe", "object", "embed", "form"],
      FORBID_ATTR: [
        "onerror",
        "onload",
        "onclick",
        "onmouseover",
        "onfocus",
        "onblur",
        "onsubmit",
        "onchange"
      ]
    };

    // Si necesitas scripts (no recomendado), puedes configurarlo
    if (allowScripts) {
      config.ALLOWED_TAGS?.push("script");
    }

    return DOMPurify.sanitize(html, config);
  }, [html, allowScripts, allowedTags, allowedAttributes]);

  return (
    <div
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizedHtml }}
    />
  );
};
